import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import Topbar from './Topbar'
import Sidebar from './Sidebar'
import BottomNav from './BottomNav'
import MobileDrawer from './MobileDrawer'

export default function Shell() {
  const [drawerOpen, setDrawerOpen] = useState(false)

  return (
    <>
      {/* Topbar */}
      <Topbar onMenuToggle={() => setDrawerOpen((v) => !v)} />

      {/* Drawer móvil — componente dedicado, todo inline, sin CSS externo */}
      {drawerOpen && <MobileDrawer onClose={() => setDrawerOpen(false)} />}

      {/* Body: sidebar (desktop) + contenido */}
      <div className="shell-body">
        <nav className="shell-sidebar">
          <Sidebar onNavigate={() => setDrawerOpen(false)} />
        </nav>
        <main className="shell-main">
          <Outlet />
        </main>
      </div>

      <BottomNav />
    </>
  )
}
